<!-- <div class="flex justify-center">
  <div class="container">
    <app-navbar></app-navbar>
    <router-outlet />
  </div>
</div> -->

@if(showLoading$ | async){
<app-loading ngSkipHydration></app-loading>
}@else {
<app-navbar></app-navbar>
<router-outlet />
<app-footer></app-footer>
<app-sidebar></app-sidebar>
}
